import React, {useState} from 'react'
import './NavSidebar.scss';
import {List, X} from "react-bootstrap-icons";


interface Props {
    children: JSX.Element[] | JSX.Element,
}

const SidebarNav = (props: Props) => {
    const [isSidebar, initSidebar] = useState(false)

    const toggleSidebar = () => {
        return initSidebar(!isSidebar);
    }

    return (
        <header className="navbar-header">
            <nav className="navbar">
                <div className="hamburger" onClick={toggleSidebar}>
                      {isSidebar ? (<X />) : (<List />)}
                </div>
                <div
                    className={"sidebar-block " + (isSidebar ? "" : "sidebar-block-hidden")}
                    onClick={toggleSidebar}
                >
                    {props.children}
                </div>
            </nav>
        </header>
    )
}

export default SidebarNav;